import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import {
  IConfigurationStaffCategoryDetailsResponse,
  IConfigurationStaffCategoryDetailsResponseData,
} from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";

import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useCurlLogger } from "../../useCurlLogger";
import AxiosCurlirize from "axios-curlirize";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useConfigurationStaffCategoryDetailsAPI = () => {
  const [staffCategoryDetails, setStaffCategoryDetails] = useState<
    IConfigurationStaffCategoryDetailsResponseData[] | null
  >(null);
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (categoryId: number) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        if (!categoryId) {
          return;
        }
        await axios
          .get(`${CONFIGURATION_APIS?.EDIT_STAFF_CATEGORY_DETAILS?.baseURL}`, {
            params: { category_id: categoryId },
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IConfigurationStaffCategoryDetailsResponse>) => {
            if (res.data.status === true) {
              setStaffCategoryDetails(res.data.data);
            } else {
              toast.error("Error while updating staff category.");
            }
          })
          .catch((e: AxiosError) => {
            captureError(e)
            sendCurl(e.config["curlCommand"]);
          });
      } catch (error) {
        // Handle errors
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          if (axiosError.code === "ERR_BAD_REQUEST") {
            toast.error("Error at server while fetching staff category details.");
          }
          if (axiosError.response?.status === 400) {
            toast.error(axiosError.message);
          }
          if (axiosError.response?.status === 500) {
            toast.error("Internal Server Error, Contact Tech Team.");
          }
        } else {
          toast.error("Server Error: " + error.message);
        }
      }
    },
    [dispatch, configuration],
  );

  return { staffCategoryDetails, execute };
};
